export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref8805.0b1f1c14.jpg";